import axios from "../utils/axios";

/**
 * List all users with pagination and advanced filtering
 * @param {Object} params - Query parameters (page, per_page, search, trashed)
 * @returns {Promise} Users list
 */
export const getUsers = async (params) => {
    try {
        const { data } = await axios.get('/users', { params });
        return data;
    } catch (error) {
        console.error("🚀 ~ getUsers ~ error:", error);
        throw error;
    }
};

/**
 * Get a single user by ID
 * @param {number|string} id - User ID
 * @returns {Promise} User data
 */
export const getUserById = async (id) => {
    try {
        const { data } = await axios.get(`/users/${id}`);
        return data;
    } catch (error) {
        console.error("🚀 ~ getUserById ~ error:", error);
        throw error;
    }
};

/**
 * Create a new user
 * @param {Object} userData - User data (name, email, password, password_confirmation, role)
 * @returns {Promise} Created user
 */
export const createUser = async (userData) => {
    try {
        const response = await axios.post('/users', userData);
        console.log("🚀 ~ createUser ~ response:", response);
        return response.data;
    } catch (error) {
        console.error("🚀 ~ createUser ~ error:", error);
        throw error;
    }
};

/**
 * Update an existing user
 * @param {number|string} id - User ID
 * @param {Object} userData - Updated user data
 * @returns {Promise} Updated user
 */
export const updateUser = async (id, userData) => {
    try {
        const { data } = await axios.put(`/users/${id}`, userData);
        return data;
    } catch (error) {
        console.error("🚀 ~ updateUser ~ error:", error);
        throw error;
    }
};

/**
 * Soft delete a user
 * @param {number|string} id - User ID
 * @returns {Promise} Result of deletion
 */
export const deleteUser = async (id) => {
    try {
        const { data } = await axios.delete(`/users/${id}`);
        return data;
    } catch (error) {
        console.error("🚀 ~ deleteUser ~ error:", error);
        throw error;
    }
};

/**
 * Force delete a user (permanent)
 * @param {number|string} id - User ID
 * @returns {Promise} Result of deletion
 */
export const forceDeleteUser = async (id) => {
    try {
        const { data } = await axios.delete(`/users/${id}/force-delete`);
        return data;
    } catch (error) {
        console.error("🚀 ~ forceDeleteUser ~ error:", error);
        throw error;
    }
};

/**
 * Restore a soft-deleted user
 * @param {number|string} id - User ID
 * @returns {Promise} Restored user
 */
export const restoreUser = async (id) => {
    try {
        const { data } = await axios.post(`/users/${id}/restore`);
        return data;
    } catch (error) {
        console.error("🚀 ~ restoreUser ~ error:", error);
        throw error;
    }
};

/**
 * Bulk soft delete users
 * @param {Array} items - Array of user IDs
 * @returns {Promise} Result
 */
export const massDestroyUsers = async (data) => {
    try {
        const response = await axios.delete('/users/mass-destroy', { data });
        return response.data;
    } catch (error) {
        console.error("🚀 ~ massDestroyUsers ~ error:", error);
        throw error;
    }
};

/**
 * Bulk force delete users
 * @param {Array} items - Array of user IDs
 * @returns {Promise} Result
 */
export const massForceDeleteUsers = async (data) => {
    try {
        const response = await axios.delete('/users/mass-force-delete', { data });
        return response.data;
    } catch (error) {
        console.error("🚀 ~ massForceDeleteUsers ~ error:", error);
        throw error;
    }
};

/**
 * Bulk restore users
 * @param {Array} items - Array of user IDs
 * @returns {Promise} Result
 */
export const massRestoreUsers = async (data) => {
    try {
        const response = await axios.post('/users/mass-restore', data);
        return response.data;
    } catch (error) {
        console.error("🚀 ~ massRestoreUsers ~ error:", error);
        throw error;
    }
};